import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

import type { SessionItem } from '../types';
import type { ApiResponse } from '@nohara-dxdev/oidc-core';

export const getSessionsQueryKey = (orgId: string, projectId: string) => [
  'chat',
  'sessions',
  orgId,
  projectId,
];

export const listSessions = async (orgId: string, projectId: string): Promise<SessionItem[]> => {
  const { data } = await api.get<undefined, ApiResponse<SessionItem[]>>(
    `/orgs/${orgId}/projects/${projectId}/ai-agent/sessions`,
  );

  return data;
};

export const useSessionsQuery = () => {
  const { orgId, projectId } = useScopeIds('org', 'project');

  return useQuery({
    queryKey: getSessionsQueryKey(orgId, projectId),
    queryFn: () => listSessions(orgId, projectId),
    enabled: !!orgId && !!projectId,
  });
};
